export default {
  en: {
    Home: {
      title: "Zaico Money Amount App",
      whatIs: "What is the Inventory Amount App?",
      thisIs:
        "This application can display and CSV download inventory amounts (purchase unit price x quantity).",
      account: "Account",
      companyName: "Company Name",
      userName: "User Name",
      planName: "Plan Name",
      changeAccount: "If you want to change your account, please log out of zaico and then reopen this screen.",
      usage: "Usage",
      makeSurePlan: "Lite Plan or higher contract is required.",
      selectPeriod: "Select the period for which you want to calculate the inventory amount.",
      selectDay: "Select the date for which you want to calculate the inventory amount",
      period: "Period",
      aLotOfInventory: "If the duration is long, it may take several minutes.",
      inBackground:
        "Since the tally runs in the background, you can move to other screens while waiting for the tally to complete, and come back to this screen later.",
      tally: "Tally",
      totalNumber: "Total number of data",
      receive: "Receive",
      shippingOut: "Shipping out",
      totalAmount: "Total amount",
      closeTallyResults: "Close tally results",
      viewTallyResults: "View tally results",
      upTo1000: "Up to 1,000 previews will be displayed.",
      CSVDownload: "download CSV",
      correctPeriodad: "Please specify the correct period.",
      Increase_or_decrease_in_the_amount_of_inventory_during_the_period: "Amount of inventory, including inbound and outbound shipments during the period",
      Amount_of_inventory_on_the_specified_date: "Amount of inventory on the specified date",
      Amount_of_inventory_on_the_specified_date: "Inventory Value on the Specified Date",
      oneday_day: "Specified Date:",
      oneday_last_price: "Use Last Purchase Price",
      oneday_fifo: "Use FIFO",
      oneday_moving_average_method: "Use Moving Average",
      hasNoPriceData1: "Warning!",
      hasNoPriceData2: "There was data for which the stock amount could not be calculated! (Row with pink background)",
      hasNoPriceData6: "Click on the preview row to open zaico's changelog screen",
      hasNoPriceData3: "[Cause]",
      hasNoPriceData4: "No incoming inventory data exists",
      hasNoPriceData5: "Incoming inventory data exists, but the unit price of incoming inventory is not entered",
      hasNoPriceData7: "No change histories linked to Receiving or Delivery",
      help_en_1: "If you have questions about the content, please check ",
      help_en_2: "the help page.",    
      detailed_data: "Detailed data (different rows for the same item but different purchase unit prices)",
      aggregate_data: "Goods aggregate data (same row for the same goods even if the purchase unit price is different)",
      advanced_plan_warning_detail_1: "・Results are limited to a maximum of five.",
      advanced_plan_warning_detail_1: "・To view the full list, you need to subscribe to a pro plan or higher.",
      only_purchase_and_packing_slip: "Historical data with no incoming or outgoing shipments are excluded from the calculation.",
      is_use_inventory_unit_price: "If there is no purchase unit price in the receiving data, the purchase unit price in the inventory data is used for calculation.",
      sort_type_option: "* If the purchase date and the delivery date are the same",
      purchase_first: "\"purchase\" is treated as first",
      delivery_first: "\"delivery\" is treated as first",
      amount: "Amount",
      totalQuantity: "Total Quantity",
      asOfSpecifiedDate: "As of {date}",
    }
  }
};
